import { Injectable } from '@angular/core';
import { LinkedIssueOverviewUpdate } from '@common/interfaces/linkedIssueOverview';
import { LinkedIssueOverviewStore } from './linkedIssueOverview.store';

@Injectable({ providedIn: 'root' })
export class LinkedIssueOverviewSyncService {
  private readonly scopes = new Map<string, string>();
  constructor(private store: LinkedIssueOverviewStore) {}

  retain(scopeKey: string, issueId: string) { this.scopes.set(scopeKey, issueId); }

  release(scopeKey: string) {
    const issueId = this.scopes.get(scopeKey);
    this.scopes.delete(scopeKey);
    if (issueId && !Array.from(this.scopes.values()).includes(issueId)) this.store.remove(issueId);
  }

  apply(scopeKey: string, updates: LinkedIssueOverviewUpdate[]) {
    const issueId = this.scopes.get(scopeKey);
    if (!issueId) return; // Ignore late responses after teardown, navigation or reconnect.
    for (const update of updates) {
      if (update.id !== issueId) continue;
      if (!update.available) {
        this.store.remove(issueId); // Authorization revocations need no entity-version increment.
        continue;
      }
      const current = this.store.getValue().entities[issueId];
      if (current?.version != null && update.version != null && current.version > update.version) continue;
      this.store.upsert(issueId, update);
    }
  }
}
